import styled, {css} from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';

interface Input {
  color?: string;
  disabled?: boolean;
  isDisplay: boolean;
  error?: boolean;
}

interface ListOptions {
  showFirstItems?: number;
}

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const ListOption = styled.ul`
  width: 100%;
  border-width: 0 1px 1px 1px;
  border-style: solid;
  border-color: ${COLORS.GRAY};
  outline: none;
  background: #fff;
  border-radius: 3px;
  width: 280px;
  overflow-y: scroll;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  display: ${(props: Input) => props.isDisplay ? 'block' : 'none'};
  max-height: ${(props: ListOptions) => props.showFirstItems && `${props.showFirstItems * 44}px` };
  
  & li:nth-child(2) {
    display: none;
  }
  &::-webkit-scrollbar {
    width: 4px;
    background-color: ${COLORS.GRAY};
  }
  &::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: ${COLORS.GRAY_PLACEHOLDER};
  }
  &::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: #fff;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    position: absolute;
    z-index: 100;
    width: auto;
    width: 100%;
    & li:nth-child(2) {
      display: block;
    }
  }
`;

export const InputMask = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 16px;
  cursor: pointer;
  height: 44px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${COLORS.GRAY};
  border-radius: 4px;
  width: 100%;
  color: #999;
  &:focus {
    outline: 0;
  }
  ${(props: Input) => props.disabled && css`
    opacity: .7;
    pointer-events: none;
    cursor: not-allowed;
  `}
  ${(props: Input) => props.error && css`
    border: 1px solid red;
  `}
`;

export const ErrorMessage = styled.span`
  color: red;
  font-size: 11px;
`;

export const Placeholder = styled.p`
  color: ${(props: Input) => props.color && props.color};
  width: 100%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LoaderWrapper = styled.span`
  right: 0;
  z-index: 10;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`

export const ListOptionModal = styled.ul`
  background: #fff;
  border-radius: 3px;
  width: 280px;
  & li:nth-child(2) {
    display: none;
  }
`;

export const ModalTitle = styled.h3`
  font-family: ${FONTS.OPEN_SANS};
  font-weight: 600;
  font-size: 14px;
  padding: 0 15px;
  line-height: 44px;
`;

export const Hidden = styled.select`
  display: none;
`;